import { render, staticRenderFns } from "./wechatLogin.vue?vue&type=template&id=f7218f16&scoped=true&"
import script from "./wechatLogin.vue?vue&type=script&lang=js&"
export * from "./wechatLogin.vue?vue&type=script&lang=js&"
import style0 from "./wechatLogin.vue?vue&type=style&index=0&id=f7218f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7218f16",
  null
  
)

export default component.exports